// Rotas da Autonomy Suite como dados (fonte: src/App.tsx); usadas no Header, Footer, Home, 404 e no Schema.org ItemList.
// D22 (Jean, 2026-09-04): o site apresenta a Zentriz como empresa de IA com um só produto-suíte — Genesis ↔ Connect ↔ Auto Care.
export interface RouteItem { slug: string; to: string }
export const SUITE_ROUTES: RouteItem[] = [
  { slug: 'genesis', to: '/genesis' },
  { slug: 'connect', to: '/connect' },
  { slug: 'autoCare', to: '/auto-care' },
]
